<div
  class="pea-pay"
  *ngIf="pedido"
  [style.--pea-primary]="primaryColor"
  (click)="fecharPagamento()"
>
  <div class="pea-pay-card" (click)="$event.stopPropagation()">
    <header class="pea-pay-head">
      <div>
        <p>Pagamento</p>
        <h2>Pedido #{{ numeroPedidoPagando }}</h2>
        <small>Total a pagar: <strong>{{ formatValor(valorPagamento) }}</strong></small>
      </div>
      <button type="button" class="pea-pay-close" (click)="fecharPagamento()" aria-label="Fechar">×</button>
    </header>

    <div class="pea-pay-tabs">
      <button
        type="button"
        [class.ativo]="metodoPagamento === 'cartao'"
        [disabled]="!metodoHabilitado('cartao')"
      >
        <i class="icofont-credit-card"></i> Cartão
      </button>
      <button
        type="button"
        [class.ativo]="metodoPagamento === 'pix'"
        [disabled]="!metodoHabilitado('pix')"
      >
        <i class="icofont-barcode"></i> Pix
      </button>
      <button
        type="button"
        [class.ativo]="metodoPagamento === 'link'"
        [disabled]="!metodoHabilitado('link')"
      >
        <i class="icofont-share-alt"></i> Link
      </button>
    </div>

    <div class="pea-pay-body" *ngIf="metodoPagamento === 'cartao'">
      <label>
        <span>Número do cartão</span>
        <input type="text" inputmode="numeric" placeholder="0000 0000 0000 0000" />
      </label>
      <label>
        <span>Nome impresso no cartão</span>
        <input type="text" placeholder="Como está no cartão" />
      </label>
      <div class="pea-pay-row">
        <label>
          <span>Validade</span>
          <input type="text" placeholder="MM/AA" />
        </label>
        <label>
          <span>CVV</span>
          <input type="text" inputmode="numeric" placeholder="123" />
        </label>
      </div>
      <label>
        <span>Parcelas</span>
        <select>
          <option>À vista · {{ formatValor(valorPagamento) }}</option>
        </select>
      </label>
      <button type="button" class="pea-pay-cta">
        <i class="icofont-credit-card"></i> Pagar {{ formatValor(valorPagamento) }}
      </button>
      <p class="pea-pay-hint">Pagamento processado em ambiente seguro.</p>
    </div>

    <div class="pea-pay-body" *ngIf="metodoPagamento === 'pix'">
      <div class="pea-pay-box">
        <div class="pea-pay-qr" *ngIf="pixImagem">
          <img [src]="pixImagem" alt="QR Code Pix" />
        </div>
        <div class="pea-pay-qr" *ngIf="!pixImagem">
          <i class="icofont-barcode"></i>
        </div>
        <p>Escaneie o QR Code no app do seu banco ou copie o código abaixo.</p>
      </div>
      <label>
        <span>Código Pix (copia e cola)</span>
        <div class="pea-pay-copy">
          <span>{{ pixCodigo || "—" }}</span>
          <button
            type="button"
            [disabled]="!pixCodigo"
            [class.ok]="linkCopiado"
            (click)="copiarPagamento(pixCodigo)"
          >
            {{ linkCopiado ? "Copiado!" : "Copiar" }}
          </button>
        </div>
      </label>
    </div>

    <div class="pea-pay-body" *ngIf="metodoPagamento === 'link'">
      <div class="pea-pay-box">
        <div class="pea-pay-qr">
          <svg class="pea-pay-link-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
        </div>
        <p>Use o link abaixo para concluir o pagamento com segurança.</p>
      </div>
      <label>
        <span>Link de pagamento</span>
        <div class="pea-pay-copy">
          <span>{{ linkPagamento || "—" }}</span>
          <button
            type="button"
            [disabled]="!linkPagamento"
            [class.ok]="linkCopiado"
            (click)="copiarPagamento(linkPagamento)"
          >
            {{ linkCopiado ? "Copiado!" : "Copiar" }}
          </button>
        </div>
      </label>
      <a
        *ngIf="linkPagamento"
        class="pea-pay-cta"
        [href]="linkPagamento"
        target="_blank"
        rel="noopener noreferrer"
      >
        Pagar
      </a>
    </div>
  </div>
</div>
